import React, { useState, useEffect } from "react";
import { useWatchState, usePage } from "@/store";
import { BaseService } from "@/service";
import { Modal, Button, Form, message, Input, Tag, Select, Icon, Popover, Checkbox } from "antd";
import { checkResult, createSelectOption } from "@/common";
import { TouchContainer } from "@/container";
import { isNullObject } from "@/check";

const { TextArea, Search } = Input;
const TABLE_NAME = "thtt_organization_group";
const NAME = "orgGroup";

const App = Form.create({ name: 'register' })((props) => {
    const { getFieldDecorator } = props.form;
    const [loading, setLoading] = useState(false);

    const [[SCOPE = []]] = useWatchState(["$_SCOPE"]);
    const [[INDUSTRY = []]] = useWatchState(["$_INDUSTRY"]);

    const [[{ title = "添加机构组", show, hide, width = 800, state, vo = {}, callback, contrast }]] = useWatchState(["modal." + NAME])

    const [orgScope, setOrgScope] = useState();
    const [orgIndustry, setOrgIndustry] = useState();

    const [selected, setSelected] = useState({
        orgs: {}
    })

    const clear = () => {
        setSelected({
            orgs: {}
        });
    }

    useEffect(() => {
        if (show) {
            clear();
            orgsControl.go(1);
        }
    }, [show])

    useEffect(() => {
        if (vo.id) getSelected(vo.id);
    }, [vo])

    const [orgs = [], orgsControl] = usePage({
        atonce: false,
        cache: true,
        service: BaseService.list,
        size: 20,
        params: {
            table: "thtt_organization",
            columns: "organization_id,name,contacts,contacts_tel,profile,user_id",
            where: JSON.stringify([
                { [`thtt_organization.is_delete`]: 0 },
                ...((orgScope && orgScope.length) || (orgIndustry && orgIndustry.length) ? ["AND"] : []),
                ...((orgScope && orgScope.length) ? [{ "thtt_organization_scope.first_scope_id": JSON.stringify(orgScope.map(({ key }) => key)) }] : []),
                ...((orgIndustry && orgIndustry.length) ? [{
                    "thtt_organization.industry_id": {
                        operator: "LIKE",
                        value: JSON.stringify(orgIndustry.map(({ key }) => key))
                    }
                }] : [])
            ]),
            leftJoin: JSON.stringify([
                {
                    table: "thtt_user",
                    on: "thtt_organization.user_id = thtt_user.user_id",
                    columns: JSON.stringify(["name AS adminUserName", "tel AS adminUserTel", "openid"])
                },
                ...((orgScope && orgScope.length) ? [{
                    table: "thtt_organization_scope",
                    on: "thtt_organization.organization_id = thtt_organization_scope.org_id",
                    columns: JSON.stringify(["first_scope_id"])
                }] : [])
            ]),
            order: JSON.stringify(["thtt_organization.add_time DESC"])
        },
        format: res => res.data.result.records
    })

    const getSelected = org_group_id => {
        BaseService.list({
            table: "thtt_organization_group_item",
            leftJoin: {
                table: "thtt_organization",
                on: `thtt_organization.organization_id = thtt_organization_group_item.org_id`,
                columns: JSON.stringify(["name"])
            },
            where: { org_group_id }
        }).then(res => {
            if (!checkResult(res)) return;
            let orgs = {};
            res.data.result.forEach(({ org_id, name }) => orgs[org_id] = name);
            selected.orgs = orgs;
            setSelected({ ...selected });
        })
    }

    useEffect(() => {
        if (orgScope || orgIndustry) {
            orgsControl.clear();
            orgsControl.go(1);
        }
    }, [orgScope, orgIndustry])

    const add = async vo => {
        setLoading(true);
        try {
            vo.add_time = Math.floor(new Date().getTime() / 1000);
            const res = await BaseService.add({ table: TABLE_NAME, data: vo });
            if (!checkResult(res)) return;

            const orgGroupId = res.data.result.id;
            const addRes = await BaseService.adds({
                table: "thtt_organization_group_item",
                data: Object.keys(selected.orgs).map(org_id => ({ org_group_id: orgGroupId, org_id }))
            })
            setLoading(false);
            if (!checkResult(addRes)) return;

            message.success("添加成功！");
            hide();
            if (callback) callback();
        } finally {
            setLoading(false);
        }
    }

    const put = async values => {
        let vo = contrast(values, ["id"]);
        setLoading(true);
        try {

            const res = await BaseService.put({ table: TABLE_NAME, data: vo, where: { id: vo.id } });
            if (!checkResult(res)) return;

            const remRes = await BaseService.remove({
                table: "thtt_organization_group_item",
                where: { org_group_id: vo.id }
            })
            if (!checkResult(remRes)) return;
            const addRes = await BaseService.adds({
                table: "thtt_organization_group_item",
                data: Object.keys(selected.orgs).map(org_id => ({ org_group_id: vo.id, org_id }))
            })
            setLoading(false);
            if (!checkResult(addRes)) return;

            message.success("修改成功！");
            hide();
            if (callback) callback();
        } finally {
            setLoading(false);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                const handler = { add, put }
                handler[state]({ ...vo, ...values });
            }
        });
    };

    // 删除已选的成果/需求
    const onCloseOrgTag = (key) => {
        delete selected.orgs[key]
        setSelected({ ...selected });
    }
    const onSearchOrg = key => {
        if (key) {
            orgsControl.params.where.name = {
                value: key,
                operator: "LIKE"
            }
        } else delete orgsControl.params.where.name
        orgsControl.go(1);
    }
    const onChangeOrgSelected = (id, name, e) => {
        if (e.target.checked) selected.orgs[id] = name;
        else delete selected.orgs[id];
        setSelected({ ...selected });
    }

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form onSubmit={handleSubmit}>

                {/* name */}
                <Form.Item label="组名称">
                    {getFieldDecorator('name', {
                        initialValue: vo["name"],
                        rules: [
                            {
                                required: false,
                                message: '请输入组名称！',
                            },
                        ],
                    })(<Input placeholder="请输入组名称" />)}
                </Form.Item>

                {/* remark */}
                <Form.Item label="备注">
                    {getFieldDecorator('remark', {
                        initialValue: vo["remark"],
                    })(<TextArea placeholder="请输入备注" />)}
                </Form.Item>

                {/* remark */}
                <Form.Item label="群组成员">
                    {/* 机构列表 */}
                    <div className="child-top-sm">
                        {/* 已选的机构 */}
                        <div className="over-auto border p-sm radius-5" style={{ height: "10vh", minHeight: "80px" }}>
                            {isNullObject(selected.orgs) ? <p className="dark-disable">已选机构</p> : Object.entries(selected.orgs).map(([key, name]) => (
                                <Tag closable onClose={onCloseOrgTag.later(key)}>{name}</Tag>
                            ))}
                        </div>
                        {/* 待选列表 */}
                        <div className="child-top-sm">
                            <div className="flex child-left-sm">
                                <Search onSearch={onSearchOrg} />
                                <Select style={{ minWidth: "150px" }} onChange={setOrgScope} placeholder="请选择领域" mode="multiple" labelInValue>
                                    {createSelectOption(SCOPE)}
                                </Select>
                                <Select style={{ minWidth: "150px" }} onChange={setOrgIndustry} placeholder="请选择行业" mode="multiple" labelInValue>
                                    {createSelectOption(INDUSTRY)}
                                </Select>
                            </div>
                            <TouchContainer onScrollBottom={orgsControl.next} className="border-b child-border-t over-auto" style={{ height: "50vh" }}>
                                {orgs.map(vo => (
                                    <div className="flex between child-left-sm">
                                        <Checkbox checked={selected.orgs[vo.organization_id]} onChange={onChangeOrgSelected.later(vo.organization_id, vo.name)}>{vo.openid && <Icon type="wechat" style={{ color: "#65b257" }} />} {vo.name}</Checkbox>
                                        <Popover content={(
                                            <div className="child-top-sm" style={{ width: "300px" }}>
                                                <div className="flex child-left-md">
                                                    <p className="child-left--mini"><Icon type="user" />
                                                        {/* <span>{vo.contacts}</span> */}
                                                        {/* <span>{vo.openid ? <Icon type="wechat" style={{ color: "#65b257" }} /> : ""}</span> */}
                                                        <span>{vo.adminUserName}</span>
                                                    </p>
                                                    <p className="child-left--mini"><Icon type="phone" /><span>{vo.adminUserTel}</span></p>
                                                </div>
                                                <p className="font-size-18 bold">机构简介</p>
                                                <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.profile }} />
                                            </div>
                                        )} title={vo.name} trigger="click">
                                            <Icon type="info-circle" />
                                        </Popover>
                                    </div>
                                ))}
                            </TouchContainer>
                        </div>
                    </div>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        保存
                    </Button>
                </Form.Item>
            </Form>

            {/* <div className="child-top-sm">
                <div className="m-push flex child-full child-left-sm self-top-sm">


                </div>
            </div> */}
        </Modal>
    );
})

export default App;